const meta = {
  notifiers: 'Notifiers',
  policies: 'Notification policies',
  signals: 'Signals',
};

export default meta;
